export default "__VITE_ASSET__Cm8ueboP__"